import { checkIfPinHasValidCoordinates } from './check-if-pin-has-valid-coordinates';

import type { Bounds, PinData } from '../Map.types';

/**
 * Returns map bounds based on the provided list of pins.
 * Returns `null` if no valid pins are provided.
 *
 * @param pins - Array of pins with lat/lng coordinates
 * @returns Map bounds format with ne (northeast) and sw (southwest) corners, or `null`
 */
export function getPinsBounds(pins: readonly PinData[]): Bounds | null {
  const validPins = pins.filter(checkIfPinHasValidCoordinates);

  if (validPins.length === 0) {
    return null;
  }

  const latitudes = validPins.map((pin) => pin.lat);
  const longitudes = validPins.map((pin) => pin.lng);

  const neLat = Math.max(...latitudes);
  const neLng = Math.max(...longitudes);
  const swLat = Math.min(...latitudes);
  const swLng = Math.min(...longitudes);

  return {
    ne: [neLng, neLat],
    sw: [swLng, swLat],
  };
}
